/* inno-social.js — the Instagram line.
   ON A PHONE it is one line under the numbered items: the homescreen's menu, the hamburger panel
   on the shop / Visit / Index overlays, and the product page's panel.
   ON A DESK it lives in one place only — beside the x/y readout under the homescreen wordmark,
   in the same micro type. It is not in the desktop page headers at all: there the header nav is
   an inline row, and a fifth, differently-set item in it broke the rhythm of the four real
   destinations. The breakpoint is the theme's own (601px), so it follows the layout rather
   than the device.
   It ships its own styling for the same reason the menu transport does (inno-player.js): the
   homepage stylesheet isn't loaded on product pages, and the markup is built here anyway. */
(function () {
  'use strict';

  var PROFILE = 'https://www.instagram.com/innocences/';
  var HANDLE = '@innocences';

  function css() {
    if (document.getElementById('inno-social-css')) return;
    var s = document.createElement('style');
    s.id = 'inno-social-css';
    var mono = 'var(--mono,"IBM Plex Mono",ui-monospace,SFMono-Regular,Menlo,monospace)';
    s.textContent =
      '.menu-ig-link{text-decoration:none;white-space:nowrap;}' +
      /* the homescreen menu: a micro readout under 04, set like the status corner */
      '#ui-layer .menu .menu-ig{margin-top:4px;}' +
      '#ui-layer .menu .menu-ig-link{display:inline-flex;align-items:center;min-height:32px;' +
        'font-family:' + mono + ';font-size:10px;font-weight:400;letter-spacing:.14em;' +
        'text-transform:uppercase;color:var(--bone,#E8E4DC);opacity:.55;transition:opacity .2s ease;}' +
      '#ui-layer .menu .menu-ig-link:hover,#ui-layer .menu .menu-ig-link:focus-visible{opacity:1;}' +
      /* the desktop homescreen: set exactly like the x/y readout it sits beside — no tap height,
         which would push it off the readout's baseline, and solid bone rather than the wordmark */
      '#ui-layer .logo-line .menu-ig-link{display:inline-block;font-family:' + mono + ';font-size:10px;' +
        'font-weight:400;font-variation-settings:normal;letter-spacing:.12em;text-transform:uppercase;' +
        'color:var(--bone,#E8E4DC);-webkit-text-stroke:0;opacity:.55;transition:opacity .2s ease;}' +
      '#ui-layer .logo-line .menu-ig-link:hover,#ui-layer .logo-line .menu-ig-link:focus-visible{opacity:1;}' +
      /* the phone panels: a line below the transport, same bracketless mono voice as it.
         !important because the panel's own list rules (56px rows, 1.25rem display type) are
         written for every link in the panel and out-rank anything injected from here. */
      '@media (max-width:600px){' +
        '.ph-nav .menu-ig,.inno-header-nav .menu-ig{padding:6px 20px 0;}' +
        '.ph-nav .menu-ig .menu-ig-link,.inno-header-nav .menu-ig .menu-ig-link{' +
          'display:inline-flex!important;align-items:center!important;gap:0!important;min-height:44px!important;padding:0!important;' +
          'font-family:' + mono + '!important;font-size:11px!important;font-weight:400!important;' +
          'font-variation-settings:normal!important;letter-spacing:.14em!important;text-transform:uppercase!important;' +
          'color:var(--bone,#E8E4DC)!important;}' +
        '.ph-nav .menu-ig .menu-ig-k,.inno-header-nav .menu-ig .menu-ig-k{opacity:.55;}' +
      '}' +
      /* wide screens: the panel is the inline header — just the handle, as a nav item */
      '@media (min-width:601px){.ph-nav .menu-ig-k,.inno-header-nav .menu-ig-k{display:none;}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function row() {
    var d = document.createElement('div');
    d.className = 'menu-ig';
    // U+FE0E keeps the arrow as a glyph — without it iOS may draw it as an emoji
    d.innerHTML = '<a class="menu-ig-link hot" href="' + PROFILE + '" target="_blank" rel="noopener noreferrer" ' +
      'aria-label="Instagram ' + HANDLE + ' (opens in a new tab)">' +
      '<span class="menu-ig-k" aria-hidden="true">IG:&nbsp;</span>' +
      '<span class="menu-ig-t">' + HANDLE + '</span>' +
      '<span aria-hidden="true">&nbsp;&#8599;&#65038;</span></a>';
    return d;
  }

  var WIDE = window.matchMedia ? window.matchMedia('(min-width: 601px)') : { matches: false };

  function own(host) {
    for (var c = host.firstElementChild; c; c = c.nextElementSibling) if (c.classList.contains('menu-ig')) return c;
    return null;
  }
  function keepLast(host, r) { if (host.lastElementChild !== r) host.appendChild(r); }

  // Panels get their other rows (the transport, the shop's filters) at different moments, so
  // this runs a few times and keeps the line LAST each time — appending an existing node moves it.
  // It also runs whenever the window crosses the breakpoint, so the line always sits where the
  // layout on screen expects it.
  function ensure() {
    css();
    var wide = WIDE.matches;

    // the homescreen: beside the readout on a desk, under the menu on a phone. ONE node, moved
    var menu = document.querySelector('#layout-1 .menu');
    var line = document.querySelector('#layout-1 .logo-line');
    var home = (line && own(line)) || (menu && own(menu)) || ((menu || line) ? row() : null);
    if (home) {
      if (wide && line) keepLast(line, home);
      else if (menu) keepLast(menu, home);
    }

    // the page headers: the phone panels keep it; the desktop inline header does not
    var heads = document.querySelectorAll('.ph-nav, .inno-header-nav');
    for (var i = 0; i < heads.length; i++) {
      var r = own(heads[i]);
      if (wide) { if (r) heads[i].removeChild(r); continue; }
      keepLast(heads[i], r || row());
    }
  }

  function boot() {
    ensure();
    setTimeout(ensure, 1000);
    setTimeout(ensure, 2700);
    document.addEventListener('inno:reveal-ui', ensure);
    if (WIDE.addEventListener) WIDE.addEventListener('change', ensure);
    else if (WIDE.addListener) WIDE.addListener(ensure);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
